// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-1d44b815] {\n  background-color: var(--vs-disabled-bg);\n  cursor: var(--vs-disabled-cursor);\n}\n.ab-btn-outline-grey[data-v-1d44b815] {\n  background-color: #fafafa;\n  border: #e2e2e2 solid 1px;\n  color: #11291b;\n}", ""]);
// Exports
module.exports = exports;
